export class Language {
  public id: number;
  public iso_code: string;
  public nls_code: string;
  public language: string;
}



// WEBPACK FOOTER //
// ./src/app/models/language.model.ts